import type { SxProps, Theme } from "@mui/material/styles";

// Shared filter-bar styling. Every filter bar imports this, so editing the look
// here updates all of them. Covers both MUI Select (.MuiOutlinedInput-root) and
// MUI X date pickers (.MuiPickersOutlinedInput-root).
export const filterPanelSx = {
  width: "100%",
  borderRadius: "14px",
  backgroundColor: (theme) =>
    theme.palette.mode === "light" ? "#f9fafb" : theme.palette.background.paper,
  border: (theme) =>
    `1px solid ${theme.palette.mode === "light" ? "#e4e7ec" : theme.palette.divider}`,
  "& .MuiOutlinedInput-root, & .MuiPickersOutlinedInput-root": {
    // Uniform height across every field type (Select / Autocomplete / date picker).
    height: 44,
    borderRadius: "10px",
    fontSize: 14,
    backgroundColor: (theme) =>
      theme.palette.mode === "light" ? "#ffffff" : theme.palette.background.default,
    "& .MuiOutlinedInput-notchedOutline, & .MuiPickersOutlinedInput-notchedOutline": {
      borderColor: (theme) => (theme.palette.mode === "light" ? "#d0d5dd" : theme.palette.divider),
    },
    "&:hover .MuiOutlinedInput-notchedOutline, &:hover .MuiPickersOutlinedInput-notchedOutline": {
      borderColor: (theme) => (theme.palette.mode === "light" ? "#d0d5dd" : theme.palette.divider),
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiPickersOutlinedInput-notchedOutline":
      {
        borderColor: "#465fff",
        borderWidth: "2px",
      },
  },
  "& .MuiInputLabel-root": { fontSize: 13, color: "#667085" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#465fff" },
  // Center the resting (non-floated) label in the 44px field; floated labels keep MUI's default.
  "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": { top: "50%", transform: "translate(14px, -50%)" },
  // Stop MUI X date sections from growing to fill the field, and hide the calendar icon.
  "& .MuiPickersInputBase-sectionsContainer": { width: "auto", flexGrow: 0 },
  "& .MuiPickersInputBase-root .MuiInputAdornment-positionEnd": { display: "none" },
} satisfies SxProps<Theme>;
